import NewOrderItemDisplayType from "../enum/NewOrderItemDisplayType";

const OrderItemDisplayTypeNameMap = {
    [NewOrderItemDisplayType.PIC]: "商品图片",

    [NewOrderItemDisplayType.SIMPLE_TITLE]: "商品简称",

    [NewOrderItemDisplayType.TITLE]: "商品标题",

    [NewOrderItemDisplayType.EXTERNAL_ID]: "商品编码",

    [NewOrderItemDisplayType.SKU_PROPERTIES]: "商品属性",

    [NewOrderItemDisplayType.GIFT]: "赠品",
};

export default OrderItemDisplayTypeNameMap;
